/**
 * Verteilungsschlüssel: capture accountCode/year from distribution/account API calls.
 */
;(function registerLuxFetchHandlerDistributionKeys() {
  luxRegisterFetchHandler({
    id: 'distribution-keys',
    priority: 50,
    match(ctx) {
      return ctx.url.includes('/distribution/account')
    },
    handle(ctx, nativeFetch) {
      try {
        const u = new URL(ctx.url, window.location.origin)
        const c = u.searchParams.get('accountCode')
        if (c) window.__wegLastDistributionAccountCode = c
        const y = u.searchParams.get('year')
        if (y) window.__wegLastDistributionAccountYear = y
      } catch (_) {
        /* ignore */
      }
      return nativeFetch.apply(this, ctx.args)
    },
  })
})()
